const getIsMac = () => navigator.userAgent.indexOf('Mac OS X') !== -1;
const KEY_NAMES: Record<string, { win?: string; mac?: string }> = {
	up: {
		win: '↑',
		mac: '↑',
	},
	down: {
		win: '↓',
		mac: '↓',
	},
	left: {
		win: '←',
		mac: '←',
	},
	right: {
		win: '→',
		mac: '→',
	},
	capslock: {
		win: '⇪',
		mac: '⇪',
	},
	meta: {
		win: 'Win',
		mac: '⌘',
	},
	shift: {
		win: '⇧',
		mac: '⇧',
	},
	ctrl: {
		win: 'Ctrl',
		mac: 'Ctrl',
	},
	alt: {
		win: 'Alt',
		mac: '⎇',
	},
	backspace: {
		mac: '⌫',
	},
	delete: {
		win: 'Del',
		mac: 'Del',
	},
	enter: {
		win: '↵',
		mac: '↵',
	},
	escape: {
		win: 'Esc',
		mac: 'Esc',
	},
	tab: {
		win: '↹',
		mac: '↹',
	},
};

const capitalize = (s: string) => {
	return s.charAt(0).toUpperCase() + s.slice(1);
};

export function normalizeKeyName(key: string): string {
	const isMac = getIsMac();

	const foundMap = KEY_NAMES[key];

	if (foundMap) {
		return foundMap[isMac ? 'mac' : 'win'] ?? key;
	}

	return capitalize(key);
}
